import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { format } from 'date-fns';
import { StyledCalendarHeader, StyledMonthYear } from './styles';
import type { CalendarHeaderProps } from './types';
const CalendarHeader = t0 => {
  const $ = _c(4);
  const {
    currentMonth
  } = t0;
  let t1;
  if ($[0] !== currentMonth) {
    t1 = format(currentMonth, "MMMM yyyy");
    $[0] = currentMonth;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formatted = t1;
  let t2;
  if ($[2] !== formatted) {
    t2 = <StyledCalendarHeader><StyledMonthYear variant="h4" title={formatted}>{formatted}</StyledMonthYear></StyledCalendarHeader>;
    $[2] = formatted;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
CalendarHeader.displayName = 'CalendarHeader';
export default CalendarHeader;